import type { RouteLocationNormalized, RouteRecordRaw } from "vue-router";
import type { Acl, User } from "vue-simple-acl/types/acl";
import { useFeature } from "~/core/composables/useFeature";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import { AppFeatures } from "~/core/models/AppFeatures.enum";
import { PATH_CARTOGRAPHY } from "~/modules/cartography/constants";
import { LicenseFeatureName } from "~/modules/license/models/LicenseFeatureName.enum";
import { useLicenseStore } from "~/modules/license/stores/useLicenseStore";

const { isFeatureEnabled } = useFeature();

const routes: RouteRecordRaw[] = [
  {
    path: PATH_CARTOGRAPHY,
    component: () => import("~/modules/cartography/views/MapDevicesPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) =>
        isFeatureEnabled(AppFeatures.CARTOGRAPHY) &&
        useLicenseStore().isLicenseFeatureEnabled(
          LicenseFeatureName.CARTOGRAPHY_FULL,
        ) &&
        can(ACLRoles.CAN_READ_DEVICE),
    },
  },
];

export default routes;
